module.exports = __webpack_public_path__ + "static/media/terms-en.11acf4f0.md";